
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMove as ObiMoveElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-move.js';
 
 
 

 
 export const ObiMove = createComponent({
   react: React,
   tagName: 'obi-move',
   elementClass: ObiMoveElement,
   events: {
     
   }
  });
 
 